import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {clientAPI} from "./axiosAnstance";
import {searchAdherentForPrecompteAPI} from "./AdherentSlice";
import axios from "axios";
import {SERVER_URL} from "../../../serverConfig";
import {getAuthHeader} from "../../../jwt/config";
import fileDownload from "js-file-download";


export const listDemandeApi = createAsyncThunk(
  "soutient/demande",
  async ({ page = 0, size = 10 }) => {
    const url = `/api/soutienScolaire/getDemandes?page=${page}&size=${size}`;
    const response = await clientAPI.get(url);
    console.log(('le liste demande:: ', response.data));
    return response.data;
  }
);
export const validationEnfantAPI = createAsyncThunk(
  "soutient/validationEnfantAPI",
  async (data, thunkAPI) => {
    try {
      const response = await clientAPI.post("/api/soutienScolaire/validationEnfant", data);
      //console.log(('le log de dession :: ', response.data));
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const incompteteSoutienAPI = createAsyncThunk(
  "soutient/incompteteSoutienAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/soutienScolaire/icompleteDemande", formData);

    return response.data;
  }
);
export const refuserSoutientAPI = createAsyncThunk(
  "soutient/refuserSoutientAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/soutienScolaire/refusDemande", formData);
    return response.data;
  }
);
export const listTypeFichierSavedSoutienAPI = createAsyncThunk(
  "soutient/listeTypeFichierSaved",
  async (idDemande) => {
    const response = await clientAPI.get("/api/soutienScolaire/listeTypeFichierSaved/" + idDemande);
    return response.data;
  }
);

export const validationSoutientAPI = createAsyncThunk(
  "soutient/validationSoutientAPI",
  async ({ id, action }, thunkAPI) => {
    try {
      const url = `/api/soutienScolaire/validation/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const listSoutientDemandeTraiteAPI = createAsyncThunk(
  "soutienScolaire/listSoutientDemandeTraiteAPI",
  async (data) => {
    const url = `/api/soutienScolaire/listeDemandeTraite`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);
export const traiteDemandeSoutienAPI = createAsyncThunk(
  "soutienScolaire/traiteDemandeSoutienAPI",
  async ({ id }, thunkAPI) => {
    try {
      const url = `/api/soutienScolaire/traiteDemande/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const downloadExportAPI = createAsyncThunk(
  "soutienScolaire/exportData",
  async (data) => {
    const token = localStorage.getItem("token");

    const d = new Date();
    const datestring =
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear() +
      "_" +
      ("0" + d.getHours()).slice(-2) +
      ("0" + d.getMinutes()).slice(-2);

    const response = await axios.post(
      `${SERVER_URL}/api/soutienScolaire/export-data`,
      data, // ✅ filtre envoyé
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    fileDownload(
      response.data,
      `Soutien_Scolaire-${datestring}.xlsx`
    );
  }
);

export const listSoutienFilterAPI = createAsyncThunk(
  "soutient/listSoutienFilterAPI",
  async (data, thunkAPI) => {
    try {
      // Extraire les paramètres de pagination
      const page = data.page || 0;
      const size = data.size || 10;
      const filters = { ...data };
      delete filters.page;
      delete filters.size;


      // Construire l'URL avec les paramètres de pagination
      const url = `/api/soutienScolaire/listFilter?page=${page}&size=${size}`;

      const response = await clientAPI.post(url, filters);

      return response.data;
    } catch (error) {
      console.error('Erreur API filtres:', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateRibAPI = createAsyncThunk(
  "soutient/updateRibAPI",
  async (data, thunkAPI) => {
    try {


      // Construire l'URL avec les paramètres de pagination
      const url = `/api/soutienScolaire/updateRib`;

      const response = await clientAPI.post(url, data);
      return response.data;
    } catch (error) {
      console.error('Erreur API filtres:', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getFileSoutienByDemandeAndType = createAsyncThunk(
  "soutient/getFileByDemandeAndType",
  async (data) => {
    return axios
      .get(
        SERVER_URL +
        `/api/soutienScolaire/getFileByDemandeAndType/${data.idDemande}/${data.id_type_fichier}`,
        {
          headers: getAuthHeader(),
          responseType: "blob",
        }
      )
      .then((res) => {
        if (data.id_type_fichier == 6)
          fileDownload(res.data, data.libelle + ".jpeg");
        else fileDownload(res.data, data.libelle + ".pdf");
      });
  }
);

export const getFileSoutienByDemandeAndEnfant = createAsyncThunk(
  "soutient/getFileSoutienByDemandeAndEnfant",
  async (data) => {
    return axios
      .get(
        SERVER_URL +
        `/api/soutienScolaire/getFileByDemandeAndEnfant/${data.idDemande}/${data.idEnfant}`,
        {
          headers: getAuthHeader(),
          responseType: "blob",
        }
      )
      .then((res) => {
          return res.data;
      });
  }
);


const SoutienScolaire = createSlice({
  name: "demande",
  initialState: {
    listDemande: [],
    listDemandeTraite: [],
    listFichierSaved: [],
    totalElements:0,
    pageNumber:0,
    pageSize:0,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listDemandeApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listDemandeApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.listDemande = action.payload.content;   // la liste
        state.totalElements = action.payload.totalElements; // total
        state.pageNumber = action.payload.number;     // page courante
        state.pageSize = action.payload.size;         // taille page

      })
      .addCase(listDemandeApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(listSoutienFilterAPI.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.listDemande = action.payload.content;   // la liste
        state.totalElements = action.payload.totalElements; // total
        state.pageNumber = action.payload.number;     // page courante
        state.pageSize = action.payload.size;         // taille page

      })
      .addCase(listTypeFichierSavedSoutienAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listFichierSaved = action.payload;
      })
      .addCase(listSoutientDemandeTraiteAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listDemandeTraite = action.payload;
      })

  },
});


export const {} = SoutienScolaire.actions;

export default SoutienScolaire.reducer;
